export const RECIEVED = 0;
export const PUBLISHED = 1;
export const DIPLOMA_SAVED = 2;
export const DIPLOMA_SENT = 3;